export const paths = {
  home: "/chat",
  login: "/login",
} as const;
